"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeConfigStore = exports.IkeConfig = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var util_1 = require("../util");
/**
 *
 */
var IkeConfig = /** @class */ (function () {
    function IkeConfig(system, env, defaults) {
        this.services = [];
        this.system = system;
        this.env = env;
        // This allows a config to be created with defaults. Useful
        // when passing variables into the client-side app from the build
        // pipeline or web server
        this.config = tslib_1.__assign({}, defaults);
    }
    Object.defineProperty(IkeConfig.prototype, "isProduction", {
        /**
         * Is this config for a production like environment
         *
         * eg Production or Preview
         */
        get: function () {
            return this.env === core_api_1.IkeEnvironment.PRODUCTION;
        },
        enumerable: false,
        configurable: true
    });
    IkeConfig.prototype.set = function (key, value) {
        this.config[key] = value;
    };
    /**
     * Determine if the key has a value
     *
     * not null or not empty string
     *
     * @param key key to check
     */
    IkeConfig.prototype.has = function (key) {
        var val = this.config[key];
        return val != null && val !== '';
    };
    /** Unset a key */
    IkeConfig.prototype.delete = function (key) {
        delete this.config[key];
    };
    /**
     *
     * @param key Config key to fetch
     * @deprecated Use specific typed getters instead
     */
    IkeConfig.prototype.get = function (key) {
        return this.config[key];
    };
    /**
     * Converts a config value to a number if it is a number
     * @returns value as a number (float) null if the value could not be parsed or undefined if the key is not set
     */
    IkeConfig.prototype.getNumber = function (key) {
        var val = this.config[key];
        if (val === undefined) {
            return undefined;
        }
        return util_1.IkeNumber.toNumber(this.config[key]);
    };
    /**
     * attempts to convert a config value to a boolean
     * boolean true and string 'true' return true
     * all other values return false
     * @param key Config key to fetch
     * @returns value as a boolean (true/false)
     */
    IkeConfig.prototype.getBoolean = function (key) {
        var val = this.config[key];
        if (val == null) {
            return false;
        }
        if (typeof val === 'boolean') {
            return val;
        }
        if (typeof val === 'string') {
            return val.toLowerCase() === 'true';
        }
        return false;
    };
    IkeConfig.prototype.getString = function (key) {
        var val = this.config[key];
        if (val == null) {
            return undefined;
        }
        if (typeof val === 'string') {
            return val;
        }
        if (typeof val === 'number') {
            return val.toString();
        }
        if (typeof val === 'boolean') {
            return val ? 'true' : 'false';
        }
        if (Array.isArray(val)) {
            return val.join(',');
        }
        if (typeof val === 'object') {
            return JSON.stringify(val);
        }
        return undefined;
    };
    IkeConfig.prototype.mustGetString = function (key) {
        var value = this.getString(key);
        if (value === undefined) {
            throw new Error("IkeConfig.mustGetString: required key \"".concat(key, "\" was not found in the config"));
        }
        return value;
    };
    /**
     * Get a config key if it is null return the default value
     *
     * @param key Config key to fetch
     * @param defaultValue Default value to return if key is not found
     */
    IkeConfig.prototype.getDefaultNumber = function (key, defaultValue) {
        var num = this.getNumber(key);
        if (num == null) {
            return defaultValue;
        }
        return num;
    };
    /**
     * Check whether all the keys are present in the config.
     *
     * @param keys List of keys that are required .
     * @returns True if a key is missing, false otherwise.
     */
    IkeConfig.prototype.requires = function (keys) {
        var _this = this;
        return keys.find(function (k) { return _this.config[k] == null; }) != null;
    };
    IkeConfig.prototype.missing = function (keys) {
        var _this = this;
        return keys.filter(function (k) { return _this.config[k] == null; });
    };
    /**
     * Register that a service was created with this config,
     * This is used to close the service we the config is destroyed
     * @param service
     */
    IkeConfig.prototype.register = function (service) {
        this.services.push(service);
    };
    /** Wait for all services that have been bound to this account to close before closing the config */
    IkeConfig.prototype.close = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.services.map(function (s) { return s.close(); }))];
                    case 1:
                        _a.sent();
                        this.services = [];
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Copy all config variables from another IkeConfig
     * @param other
     */
    IkeConfig.prototype.extend = function (other) {
        var _this = this;
        Object.keys(other.toJSON().keys).forEach(function (k) { return _this.set(k, other.get(k)); });
    };
    IkeConfig.prototype.toJSON = function () {
        return {
            env: this.env,
            system: this.system,
            keys: this.config
        };
    };
    IkeConfig.prototype.toString = function () {
        return "Config: ".concat(this.system, ":").concat(this.env);
    };
    return IkeConfig;
}());
exports.IkeConfig = IkeConfig;
var IkeConfigStore = /** @class */ (function () {
    function IkeConfigStore() {
    }
    IkeConfigStore.get = function (system, env) {
        var key = IkeConfigStore.makeKey(system, env);
        var store = IkeConfigStore.stores[key];
        if (store == null) {
            throw new Error('Invalid system/environment combination: ' + key);
        }
        return store;
    };
    IkeConfigStore.register = function (cfg) {
        var key = IkeConfigStore.makeKey(cfg.system, cfg.env);
        var store = IkeConfigStore.stores[key];
        if (store != null) {
            throw new Error('Store has already been registered: ' + cfg.toString());
        }
        IkeConfigStore.stores[key] = cfg;
    };
    IkeConfigStore.makeKey = function (system, env) {
        return "".concat(system, ":").concat(env).toLowerCase();
    };
    IkeConfigStore.stores = {};
    IkeConfigStore.MAX_SEARCH_LENGTH = 512;
    return IkeConfigStore;
}());
exports.IkeConfigStore = IkeConfigStore;
//# sourceMappingURL=store.js.map